import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class FieldSyncAssetUpdatedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: FieldSyncAssetUpdatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldSyncAssetUpdatedEvent.type = 'com.treeplotter.api.asset.fieldSyncAssetUpdated.v1';
EventRegistry.register(FieldSyncAssetUpdatedEvent.type, FieldSyncAssetUpdatedEvent);
//# sourceMappingURL=field-sync-asset-updated.event.js.map